<template>
	<v-list-item
		style="border: 1px solid #e0e0e0; border-radius: 5px"
	>
		<v-list-item-content>
			<v-list-item-title>
				<strong>{{ appLocation.name }}</strong>
			</v-list-item-title>
		</v-list-item-content>
		<v-list-item-action>
			<v-row no-gutters>
				<v-btn icon @click="showForm = true">
					<v-icon color="primary">edit</v-icon>
				</v-btn>
				<v-btn icon @click="showDeleteAppointmentLocation = true">
					<v-icon color="primary">delete</v-icon>
					<DeleteConfirmationDialog
						v-model="showDeleteAppointmentLocation"
						item="appointment_location"
						@delete="deleteAppointmentLocation"
					/>
				</v-btn>
        <v-dialog v-model="showForm" max-width="40%" scrollable>
          <v-card>
            <v-card-title class="title primary--text mb-2 secondary">
              <translate>Office</translate>
            </v-card-title>
            <v-card-text>
              <v-form ref="form">
                <v-row no-gutters class="mt-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="appLocation.name"
                      :label="$gettext('Name')"
                      filled
                      hide-details
                      class="pa-2"
                      :rules="[required]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="showForm = false">
                <translate>Cancel</translate>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="editAppointmentLocation" key="save" :loading="savingAppointmentLocation">
                <translate>Save</translate>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
			</v-row>
		</v-list-item-action>
	</v-list-item>
</template>

<script>
import axios from "axios";
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";

export default {
  name: "AppointmentLocation",
  props: ["appLocation"],
  components: {
    DeleteConfirmationDialog
  },
  data: () => ({
    showDeleteAppointmentLocation: false,
    showForm: false,
    savingAppointmentLocation: false
  }),
  computed: {
    required() {
			return value => !!value || this.$gettext("Required.");
		}
  },
  methods: {
    deleteAppointmentLocation() {
      let id = this.appLocation.id;
      if(id) {
        axios
          .post("/appointment-location/" + this.appLocation.id + "/delete")
          .then(response => {
            console.log(response.data);
            this.$emit('remove-appointment-location', this.appLocation);
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => this.showDeleteAppointmentLocation = false);
      } else this.$emit('remove-appointment-location', this.appLocation);
    },
    editAppointmentLocation() {
      if(this.$refs.form.validate()) {
        let id = this.appLocation.id;
        if(id) {
          this.savingAppointmentLocation = true;
          axios
            .post("/appointment-location/" + id + "/edit", {name: this.appLocation.name})
            .then(response => {
              console.log(response.data);
              this.showForm = false;
            })
            .catch(error => {
              console.log(error);
            })
            .finally(() => this.savingAppointmentLocation = false);
        } else this.showForm = false;
      }
    }
  }
}
</script>